module.exports = __webpack_public_path__ + "static/img/m-banner.16e1460.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/m-banner.jpg
// module id = Vftg
// module chunks = 1